import {combineReducers} from 'redux';
import privacyPolicy from '../components/privacy-policy/state';

export default combineReducers({
  privacyPolicy,
});
